import React, { useState } from 'react';
import {
  Box, Container, Typography, Grid, Stack, Chip, Card, Tabs, Tab,
} from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const trendingApps = [
  { name: 'Claude Code', desc: 'Persistent coding workspace', trending: true, abbr: 'CC', color: '#D97706', bg: '#FEF3C7', imgSrc: '/assets/vps-deploy/application/claudecode.svg' },
  { name: 'Hermes Agent', desc: 'AI task automation', trending: true, abbr: 'HA', color: '#7C3AED', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/application/hermes-agent.avif' },
  { name: 'Hermes Agent + Open WebUI', desc: 'Agent chat workspace', trending: true, abbr: 'HW', color: '#2563EB', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/application/hermes-agent.avif' },
  { name: 'n8n', desc: 'Automate workflows easily', trending: true, abbr: 'n8', color: '#EA4A00', bg: '#FFF3EE', imgSrc: '/assets/vps-deploy/application/n8n-2.svg' },
  { name: 'OpenClaw', desc: 'Self-hosted AI agents', trending: true, abbr: 'OC', color: '#059669', bg: '#ECFDF5', imgSrc: '/assets/vps-deploy/application/openclaw-3.svg' },
  { name: 'Open WebUI', desc: 'Private AI chat', trending: true, abbr: 'OW', color: '#0284C7', bg: '#E0F2FE', imgSrc: '/assets/vps-deploy/application/open-webui.svg' },
];
// ─── Tab 0: All Applications & Stacks ───────────────────────────────────────
const otherApps = [
  { name: 'BMAD', desc: 'AI Agent Framework', abbr: 'BM', color: '#6366F1', bg: '#EEF2FF', imgSrc: '/assets/vps-deploy/application/bmad.avif' },
  { name: 'Chatwoot', desc: 'Customer support platform', abbr: 'CW', color: '#1D4ED8', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/application/chatwoot.svg' },
  { name: 'Coolify', desc: 'Deploy apps easily', abbr: 'CF', color: '#7C3AED', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/application/coolify-1.svg' },
  { name: 'DeepSeek', desc: 'Private AI model hosting', abbr: 'DS', color: '#0F766E', bg: '#CCFBF1', imgSrc: '/assets/vps-deploy/application/deep.svg' },
  { name: 'Dify', desc: 'AI app development platform', abbr: 'DY', color: '#2563EB', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/application/dify-color.svg' },
  { name: 'GatorClaw', desc: 'AI automation runtime', abbr: 'GC', color: '#15803D', bg: '#F0FDF4', imgSrc: '/assets/vps-deploy/application/gatorclaw-1.svg' },
  { name: 'Ghost', desc: 'Modern publishing platform', abbr: 'GH', color: '#1E293B', bg: '#F1F5F9', imgSrc: '/assets/vps-deploy/application/ghost-platform-icon.svg' },
  { name: 'Jitsi Meet', desc: 'Video conferencing', abbr: 'JM', color: '#EA580C', bg: '#FFF7ED', imgSrc: '/assets/vps-deploy/application/jitsi.svg' },
  { name: 'LAMP Stack', desc: 'Apache, MySQL, PHP', abbr: 'LA', color: '#B45309', bg: '#FFFBEB', imgSrc: '/assets/vps-deploy/application/lamp-stack.svg' },
  { name: 'Langflow', desc: 'Visual AI workflow builder', abbr: 'LF', color: '#6D28D9', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/application/langflow.svg' },
  { name: 'LEMP Stack', desc: 'Nginx, MySQL, PHP', abbr: 'LE', color: '#047857', bg: '#ECFDF5', imgSrc: '/assets/vps-deploy/application/lemp-stack.svg' },
  { name: 'Magento', desc: 'Scalable eCommerce hosting', abbr: 'MG', color: '#B45309', bg: '#FEF3C7', imgSrc: '/assets/vps-deploy/application/magento-1.svg' },
  { name: 'Moodle', desc: 'Online learning platform', abbr: 'MO', color: '#B91C1C', bg: '#FEF2F2', imgSrc: '/assets/vps-deploy/application/Moodle-Logo.svg' },
  { name: 'NanoClaw', desc: 'Always-on AI agent', abbr: 'NC', color: '#0369A1', bg: '#E0F2FE', imgSrc: '/assets/vps-deploy/application/nanoclaw.avif' },
  { name: 'Odoo', desc: 'Complete business suite', abbr: 'OD', color: '#7C3AED', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/application/Official_Odoo_logo.svg' },
  { name: 'Ollama', desc: 'Self-hosted AI models', abbr: 'OL', color: '#1E293B', bg: '#F1F5F9', imgSrc: '/assets/vps-deploy/application/ollama.svg' },
  { name: 'OpenLiteSpeed & WordPress', desc: 'High-speed WordPress', abbr: 'OW', color: '#2563EB', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/application/wp-ols.avif' },
  { name: 'OpenLiteSpeed + Node.js', desc: 'Fast Node.js hosting', abbr: 'ON', color: '#15803D', bg: '#F0FDF4', imgSrc: '/assets/vps-deploy/application/nodejs.svg' },
  { name: 'Paperclip', desc: 'AI document workspace', abbr: 'PC', color: '#DC2626', bg: '#FEF2F2', imgSrc: '/assets/vps-deploy/application/paperclip-1.svg' },
  { name: 'Portainer', desc: 'Manage containers visually', abbr: 'PT', color: '#0369A1', bg: '#E0F2FE', imgSrc: '/assets/vps-deploy/application/portainer.svg' },
  { name: 'Rocket.Chat', desc: 'Secure team messaging', abbr: 'RC', color: '#C2410C', bg: '#FFF7ED', imgSrc: '/assets/vps-deploy/application/rocket-chat-icon-svgrepo-com.svg' },
  { name: 'Sim', desc: 'Visual AI workflows', abbr: 'SM', color: '#6366F1', bg: '#EEF2FF', imgSrc: '/assets/vps-deploy/application/sim.avif' },
  { name: 'WooCommerce (WordPress)', desc: 'Flexible online store', abbr: 'WC', color: '#7C3AED', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/application/WooCommerce-Logo.svg' },
  { name: 'WordPress', desc: 'Build websites faster', abbr: 'WP', color: '#2563EB', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/application/wordpress-24.svg' },
];
// ─── Tab 1: OS With Panel ────────────────────────────────────────────────────

const panels = [
  { name: 'cPanel', desc: 'Trusted hosting control', trending: true, abbr: 'cP', color: '#B45309', bg: '#FEF3C7', imgSrc: '/assets/vps-deploy/os-with-panel/cpanel-5.svg' },
  { name: 'aaPanel', desc: 'Simple server control', abbr: 'aP', color: '#15803D', bg: '#F0FDF4', imgSrc: '/assets/vps-deploy/os-with-panel/AaPanel_Logo.avif' },
  { name: 'CloudPanel', desc: 'Modern server management', abbr: 'CL', color: '#0284C7', bg: '#E0F2FE', imgSrc: '/assets/vps-deploy/os-with-panel/cloudpanel.svg' },
  { name: 'Cloudron', desc: 'Self-hosted app platform', abbr: 'CR', color: '#7C3AED', bg: '#EDE9FE', imgSrc: '/assets/vps-deploy/os-with-panel/cloudron.svg' },
  { name: 'CyberPanel', desc: 'OpenLiteSpeed control panel', abbr: 'CP', color: '#0F766E', bg: '#CCFBF1', imgSrc: '/assets/vps-deploy/os-with-panel/cyberpanel.svg' },
  { name: 'Easypanel', desc: 'Simple app deployment', abbr: 'EP', color: '#2563EB', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/os-with-panel/easypanel.svg' },
  { name: 'HestiaCP', desc: 'Lightweight hosting control panel', abbr: 'HC', color: '#EA580C', bg: '#FFF7ED', imgSrc: '/assets/vps-deploy/os-with-panel/hestia.svg' },
  { name: 'ISPConfig 3', desc: 'Open-source hosting control', abbr: 'IC', color: '#1E293B', bg: '#F1F5F9', imgSrc: '/assets/vps-deploy/os-with-panel/ispconfig.svg' },
  { name: 'WebAdmin', desc: 'Web-based administration', abbr: 'WA', color: '#6366F1', bg: '#EEF2FF', imgSrc: '/assets/vps-deploy/os-with-panel/web-admin.svg' },
  { name: 'AdminBolt', desc: 'Lightweight management panel', abbr: 'AB', color: '#B91C1C', bg: '#FEF2F2', imgSrc: '/assets/vps-deploy/os-with-panel/adminbolt.avif' },
  { name: 'Webuzo', desc: 'Hosting control panel', abbr: 'WB', color: '#9333EA', bg: '#FAF5FF', imgSrc: '/assets/vps-deploy/os-with-panel/webuzo.avif' },
];
// ─── Tab 2: Plain OS ─────────────────────────────────────────────────────────
const plainOS = [
  { name: 'AlmaLinux', desc: 'Stable enterprise Linux', trending: true, abbr: 'AL', color: '#B91C1C', bg: '#FEF2F2', imgSrc: '/assets/vps-deploy/plain-os/almalinux-2.avif' },
  { name: 'Ubuntu', desc: 'Developer-friendly Linux server', trending: true, abbr: 'UB', color: '#E05D04', bg: '#FFF3EE', imgSrc: '/assets/vps-deploy/plain-os/ubuntu-1.svg' },
  { name: 'CentOS', desc: 'Reliable Linux server', abbr: 'CO', color: '#15803D', bg: '#F0FDF4', imgSrc: '/assets/vps-deploy/plain-os/centos-1.svg' },
  { name: 'Debian', desc: 'Stable open-source Linux', abbr: 'DE', color: '#C2410C', bg: '#FFF7ED', imgSrc: '/assets/vps-deploy/plain-os/debian-1.svg' },
  { name: 'Fedora', desc: 'Modern developer Linux', abbr: 'FE', color: '#1D4ED8', bg: '#EFF6FF', imgSrc: '/assets/vps-deploy/plain-os/fedora.svg' },
  { name: 'Rocky Linux', desc: 'Enterprise-ready Linux', abbr: 'RL', color: '#15803D', bg: '#F0FDF4', imgSrc: '/assets/vps-deploy/plain-os/rocky-linux-1.svg' },
];

// App Icon: shows real image if available, else fallback abbr avatar
const AppIcon = ({ app }) => (
  <Box sx={{
    width: 42, height: 42, borderRadius: '10px',
    background: app.bg,
    border: `1.5px solid ${app.color}22`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, overflow: 'hidden',
  }}>
    <img
      src={app.imgSrc}
      alt={app.name}
      width={28}
      height={28}
      style={{ objectFit: 'contain', display: 'block' }}
      onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
    />
    <Typography
      style={{ display: 'none', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '0.7rem', color: app.color, letterSpacing: '0.03em' }}
    >
      {app.abbr}
    </Typography>
  </Box>
);

const AppCard = ({ app }) => (
  <Card elevation={0} sx={{
    border: `1px solid ${C.border}`,
    borderRadius: '12px',
    p: '14px 16px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    background: '#FFFFFF',
    cursor: 'pointer',
    transition: 'all 0.18s',
    '&:hover': {
      borderColor: C.primary,
      background: '#EFF6FF',
      boxShadow: '0 4px 16px rgba(37,99,235,0.09)',
      transform: 'translateY(-1px)',
    },
  }}>
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
      <AppIcon app={app} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexWrap: 'nowrap', mb: 0.25 }}>
          <Typography sx={{
            color: '#0F172A', fontWeight: 700, fontSize: '0.88rem', whiteSpace: 'nowrap',
            overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            {app.name}
          </Typography>
          {app.trending && (
            <Chip label="HOT" size="small" sx={{
              fontSize: '0.58rem', fontWeight: 800, height: 16, px: 0.5,
              background: '#FEF3C7', color: '#B45309', border: '1px solid #F59E0B40',
              flexShrink: 0,
            }} />
          )}
        </Stack>
        <Typography sx={{ color: '#64748B', fontSize: '0.78rem', lineHeight: 1.35 }} noWrap>
          {app.desc}
        </Typography>
      </Box>
    </Stack>
    <ChevronRight sx={{ color: '#CBD5E1', fontSize: 18, flexShrink: 0, ml: 1 }} />
  </Card>
);

const VpsDeploy = () => {
  const [tab, setTab] = useState(0);

  const tabLabels = ['Applications & Agents', 'OS With Panel', 'Plain OS'];

  return (
    <Section id="deploy" sx={{ background: '#F8FAFC', borderBottom: `1px solid ${C.border}`, py: { xs: 8, md: 11 } }}>
      <Container maxWidth="lg">

        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <SectionLabel>ONE-CLICK DEPLOY</SectionLabel>
          <Typography variant="h2" sx={{
            fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.6rem' },
            color: '#0F172A', letterSpacing: '-0.03em', mb: 1.5,
          }}>
            Deploy in one click on your VPS
          </Typography>
          <Typography sx={{ color: '#475569', fontSize: '1.02rem', maxWidth: 640, mx: 'auto', lineHeight: 1.65 }}>
            Spin up popular Linux distros, control panels, and applications on your Hosting Services VPS.
            Pick a stack and we'll have you running in minutes — no manual setup required.
          </Typography>
        </Box>

        {/* Category Tabs - pill style */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 5 }}>
          <Box sx={{
            display: 'inline-flex',
            background: '#FFFFFF',
            border: `1.5px solid ${C.border}`,
            borderRadius: '14px',
            p: '5px',
            gap: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          }}>
            {tabLabels.map((label, idx) => (
              <Box
                key={label}
                onClick={() => setTab(idx)}
                sx={{
                  px: { xs: 2, md: 3.5 },
                  py: '9px',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontWeight: 700,
                  fontSize: { xs: '0.82rem', md: '0.9rem' },
                  letterSpacing: '-0.01em',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.18s',
                  userSelect: 'none',
                  color: tab === idx ? '#FFFFFF' : '#475569',
                  background: tab === idx ? '#2563EB' : 'transparent',
                  boxShadow: tab === idx ? '0 2px 10px rgba(37,99,235,0.28)' : 'none',
                  '&:hover': tab === idx ? {} : {
                    background: '#F1F5F9',
                    color: '#0F172A',
                  },
                }}
              >
                {label}
              </Box>
            ))}
          </Box>
        </Box>

        {/* Tab 0: Applications & Agents */}
        {tab === 0 && (
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.12em', color: '#2563EB', textTransform: 'uppercase', mb: 2.5 }}>
              🔥 Trending Apps & Agents
            </Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              {trendingApps.map((app) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={app.name}>
                  <AppCard app={app} />
                </Grid>
              ))}
            </Grid>

            <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.12em', color: '#94A3B8', textTransform: 'uppercase', mb: 2.5 }}>
              All Applications & Stacks
            </Typography>
            <Grid container spacing={2}>
              {otherApps.map((app) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={app.name}>
                  <AppCard app={app} />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        {/* Tab 1: OS With Panel */}
        {tab === 1 && (
          <Grid container spacing={2}>
            {panels.map((app) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={app.name}>
                <AppCard app={app} />
              </Grid>
            ))}
          </Grid>
        )}

        {/* Tab 2: Plain OS */}
        {tab === 2 && (
          <Grid container spacing={2}>
            {plainOS.map((app) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={app.name}>
                <AppCard app={app} />
              </Grid>
            ))}
          </Grid>
        )}

      </Container>
    </Section>
  );
};

export default VpsDeploy;
